/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { RegistryTypeResponse } from '../../models/registry-type-response';

export interface RegistryControllerGetTypes$Params {
}

export function registryControllerGetTypes(http: HttpClient, rootUrl: string, params?: RegistryControllerGetTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: RegistryTypeResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, registryControllerGetTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: RegistryTypeResponse;
      }>;
    })
  );
}

registryControllerGetTypes.PATH = '/registry/types';
